'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

require('./objectAssign');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// Derived straight from the source:
// github.com/facebook/react/blob/master/src/classic/types/ReactPropTypes.js
function makeChainable(validate) {
  function checkType(isRequired, props, propName, componentName, location) {
    componentName = componentName || 'ANONYMOUS';
    if (props[propName] == null) {
      if (isRequired) {
        return new Error('Required prop `' + propName + '` was not specified in ' + ('`' + componentName + '`.'));
      }
      return null;
    }

    return validate(props, propName, componentName, location);
  }

  var chainedCheckType = checkType.bind(null, false);
  chainedCheckType.isRequired = checkType.bind(null, true);

  return chainedCheckType;
}

/**
 * React PropTypes helper that allows you to register your own validations,
 * which support `.isRequired` chaining. Takes an optional set of
 * existing PropTypes to start with.
 */

var PropTypes = function () {
  function PropTypes() {
    var existingPropTypes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, PropTypes);

    // shallow clone original object
    Object.assign(this, existingPropTypes);
  }

  _createClass(PropTypes, [{
    key: 'register',
    value: function register(key, validator) {
      if (this[key] != null) {
        throw new Error('Prop Validator with name `' + key + '` already exists.');
      }
      this[key] = validator.dontWrap ? validator : makeChainable(validator);
      return this;
    }
  }, {
    key: 'registerAll',
    value: function registerAll(obj) {
      var _this = this;

      Object.keys(obj).forEach(function (key) {
        if (key !== '__esModule') {
          _this.register(key, obj[key]);
        }
      });
      return this;
    }
  }]);

  return PropTypes;
}();

exports.default = PropTypes;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/react-utils/static-2.43/js/PropTypesRegistry.js
// module id = 105
// module chunks = 0